export default __webpack_public_path__ + "static/media/icons-mic.bfa5d867.svg";